import * as React from "react";

type ZigzagIconProps = {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  variant?: "desktop" | "mobile";
};

const ZigzagIcon = ({
  width = "100%",
  height,
  className,
  style,
  color = "#D1D3D4",
  variant = "desktop",
}: ZigzagIconProps) => {
  if (variant === "mobile") {
    return (
      <svg
        width={width}
        height={height || 11}
        viewBox="0 0 402 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
        preserveAspectRatio="none"
      >
        <path
          d="M0.707031 9.41418L8.70706 1.41418L16.7071 9.41418L24.7071 1.41418L32.7071 9.41418L40.7071 1.41418L48.7071 9.41418L56.7071 1.41418L64.7071 9.41418L72.7071 1.41418L80.7071 9.41418L88.7071 1.41418L96.7071 9.41418L104.707 1.41418L112.707 9.41418L120.707 1.41418L128.707 9.41418L136.707 1.41418L144.707 9.41418L152.707 1.41418L160.707 9.41418L168.707 1.41418L176.707 9.41418L184.707 1.41418L192.707 9.41418L200.707 1.41418L208.707 9.41418L216.707 1.41418L224.707 9.41418L232.707 1.41418L240.707 9.41418L248.707 1.41418L256.707 9.41418L264.707 1.41418L272.707 9.41418L280.707 1.41418L288.707 9.41418L296.707 1.41418L304.707 9.41418L312.707 1.41418L320.707 9.41418L328.707 1.41418L336.707 9.41418L344.707 1.41418L352.707 9.41418L360.707 1.41418L368.707 9.41418L376.707 1.41418L384.707 9.41418L392.707 1.41418L400.707 9.41418"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height || 21}
      viewBox="0 0 1378 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      preserveAspectRatio="none"
    >
      <path
        d="M0.547363 19.1949L28.0674 1.19495L55.5875 19.1949L83.1075 1.19495L110.627 19.1949L138.147 1.19495L165.667 19.1949L193.188 1.19495L220.708 19.1949L248.228 1.19495L275.748 19.1949L303.268 1.19495L330.788 19.1949L358.308 1.19495L385.828 19.1949L413.347 1.19495L440.867 19.1949L468.387 1.19495L495.907 19.1949L523.427 1.19495L550.947 19.1949L578.468 1.19495L605.988 19.1949L633.508 1.19495L661.028 19.1949L688.548 1.19495L716.068 19.1949L743.588 1.19495L771.108 19.1949L798.628 1.19495L826.148 19.1949L853.668 1.19495L881.188 19.1949L908.708 1.19495L936.228 19.1949L963.748 1.19495L991.268 19.1949L1018.79 1.19495L1046.31 19.1949L1073.83 1.19495L1101.35 19.1949L1128.87 1.19495L1156.39 19.1949L1183.91 1.19495L1211.43 19.1949L1238.95 1.19495L1266.47 19.1949L1293.99 1.19495L1321.51 19.1949L1349.03 1.19495L1376.55 19.1949"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default ZigzagIcon;
